/* This component can be used on its own, but also in combination with PopoverOverlay -> go
 there for more info */

import { useTranslation } from 'react-i18next'
import { cloneElement, ReactElement, useRef, useState } from 'react'
import OverlaySelectWrapper from '@/components/common/propertyPopoverOverlay/overlay/OverlaySelectWrapper.tsx'
import OverlaySelectOpened from '@/components/common/propertyPopoverOverlay/overlay/OverlaySelectOpened.tsx'
import useHandleClickOutside from '@/lib/hooks/useHandleClickOutside.ts'
import PropertyPopoverTrigger from '@/components/common/propertyPopoverOverlay/PropertyPopoverTrigger.tsx'
import { PopoverOverlayT } from '@/components/common/propertyPopoverOverlay/PopoverOverlay.tsx'
import TriggerWithCloseBtnWrapper from '@/components/common/propertyPopoverOverlay/TriggerWithCloseBtnWrapper.tsx'
import OverlayBackdrop from '@/components/common/propertyPopoverOverlay/overlay/OverlayBackdrop.tsx'
import { useOverlayStore } from '@/components/common/propertyPopoverOverlay/overlay/useOverlayStore.ts'
import { cn } from '@/lib/utils.ts'

export const Overlay = ({
  onClose,
  searchLabel,
  properties,
  customTrigger,
  className,
  XBtn,
  ...props
}: PopoverOverlayT) => {
  const { t } = useTranslation()
  const ref = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)

  const disableClosingOverlay = useOverlayStore(state => state.disableClosingOverlay)

  function handleClose() {
    document.body.style.overflow = 'unset'
    onClose && onClose()
    setOpen(false)
  }

  function handleOpen() {
    setOpen(true)
    document.body.style.overflow = 'hidden'
  }

  const clickOutsideDisabled = !open || disableClosingOverlay
  useHandleClickOutside(clickOutsideDisabled, handleClose, ref)

  // clone custom trigger and attach the handleClick prop
  let customBtn = customTrigger
    ? cloneElement(customTrigger as ReactElement, { handleClick: handleOpen })
    : null

  const trigger = customBtn ?? (
    <PropertyPopoverTrigger handleClick={handleOpen} variant={XBtn ? 'ghost' : 'outline'} />
  )

  return (
    <>
      {XBtn ? (
        <TriggerWithCloseBtnWrapper
          onClick={XBtn.onClick}
          variant={XBtn.variant}
          size={XBtn.size}
          trigger={trigger}
        />
      ) : (
        trigger
      )}

      <OverlayBackdrop open={open} className={`md:hidden`} />
      <OverlaySelectWrapper open={open} handleSwipeDown={handleClose} className={`md:w-full`}>
        <div
          ref={ref}
          // className={`z-[10010] w-full overflow-y-auto rounded border-t bg-white py-2 shadow-2xl`}
          className={cn(
            `z-[10010] w-full rounded border-t bg-white pb-6 pt-2 shadow-2xl`,
            className,
          )}
        >
          <OverlaySelectOpened
            properties={properties}
            searchLabel={searchLabel ?? t(`common.show`)}
            handleClose={handleClose}
            open={open}
            {...props}
          />
        </div>
      </OverlaySelectWrapper>
    </>
  )
}
